import { SharedStyles } from '@opencare/shared-styles';
import styled from 'styled-components';

import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { BaseBodyText } from 'pages/checkout/components/common/typographic-styled-components';
import { NoGiftIcon } from 'pages/common/components/svgs/NoGiftIcon';

// These should be added to SharedStyles
const ALPHA_SECONDARY_30 = 'rgba(97, 129, 150, 0.30)';
const ALPHA_SECONDARY_10 = 'rgba(97, 129, 150, 0.10)';

export const Wrapper = styled.div`
  display: flex;
  padding: 12px 20px 16px 12px;
  align-items: flex-start;
  gap: 8px;

  border-radius: 12px;
  border: 1px solid ${ALPHA_SECONDARY_30};
  background: ${ALPHA_SECONDARY_10};
`;

export const StyledNoGiftIcon = styled(NoGiftIcon)`
  flex-shrink: 0;
`;

export const Text = styled(BaseBodyText)`
  line-height: 20px;
  color: ${SharedStyles.COLOR.TEXT.DEFAULT.HEADING};
  display: inline;
`;

export const IneligibleText = styled(Text)`
  ${TYPOGRAPHY.OPEN_SANS.semiBold}
`;
